import React, { useEffect, useState } from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import { Bar, Pie, Line } from 'react-chartjs-2';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
// import ChartistGraph from 'react-chartist';
import axios from 'axios';
import Tasks from "components/Tasks/Tasks.js";
import TextField from '@material-ui/core/TextField';
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import config from '../../lib/config';
import CardFooter from "components/Card/CardFooter.js";
import { bugs, website, server } from "variables/general.js";
import DatePicker from 'react-datepicker'
import { getusercount, gettransation, getgraphicalcount, getGraphicalDateData, getsupportcount } from '../../actions/users';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { CSVLink } from "react-csv";
import CsvDownloader from 'react-csv-downloader';


import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);
var dateFormat = require('dateformat');
const moment = require('moment')

const initialFormValue = {

  'startdate': "",
  'enddate': "",
  'dob': ''

}


export default function Dashboard() {
  const classes = useStyles();
  const [counts, setcounts] = useState();
  const [transactioncount, settransactioncount] = useState();
  const [supportcounts, setsupportcounts] = useState();
  const [formvalue, setFormValue] = useState(initialFormValue)
  const [amount, setamount] = useState();
  const [lables, setlabels] = useState();
  const [chartdatas, setchartdatas] = useState({});
  const [result, setresult] = useState([]);
  const [chartvalue, setChartvalue] = useState({});
  const [buttonset, setbuttonset] = useState(0);
  const [day, setday] = useState([]);
  const [week, setweek] = useState([]);
  const [month, setmonth] = useState([]);
  const [year, setyear] = useState([]);
  const [usd, setusd] = useState('');



  // const columns2 = [

  //   {
  //     id: 'Amount',
  //     displayName: 'Amount'
  //   },
  //   {
  //     id: 'Type',
  //     displayName: 'Type'
  //   },
  //   {
  //     id: 'No of Transactions',
  //     displayName: 'No of Transactions'
  //   }

  // ];





  const { startdate, enddate, dob } = formvalue;

  const getcount = async () => {

    const count = await getusercount();
    setcounts(count.userValue);
  }

  const getSupportcount = async () => {

    const count = await getsupportcount();
    setsupportcounts(count.userValue);
  }


  useEffect(() => {
    getcount();
    gettransation1();
    getGraphicalCount();
    getSupportcount();
    //  chart();


  }, [])



  const gettransation1 = async () => {
    const { transactionCount } = await gettransation();
    settransactioncount(transactionCount);
  }

  const getGraphicalCount = async () => {

    const { results } = await getgraphicalcount();
    setChartvalue(results);
    var superMerchantarray = [];



    results.map((elt, i) => {
      console.log("kkkkkkkkk", dateFormat(elt.day))
      const obj = { 'Type': elt.type, 'Amount': elt.Amount, 'No of Transactions': elt.count, 'Start Dat11e': dateFormat(elt.startdate, 'dd-mm-yyyy h:MM:ss TT'), 'End Date': dateFormat(elt.enddate, 'dd-mm-yyyy h:MM:ss TT') };
      superMerchantarray.push(obj);
    })
    console.log("superMerchantarray", superMerchantarray)
    setChartvalue(superMerchantarray);
  }


  

  




  

 

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Total Users</p>
              <h3 className={classes.cardTitle}>
                {counts}
              </h3>
            </CardHeader>

          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p className={classes.cardCategory}>Total Transactions</p>
              <h3 className={classes.cardTitle}>{transactioncount}</h3>
            </CardHeader>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p className={classes.cardCategory}>Total Support Messages</p>
              <h3 className={classes.cardTitle}>{supportcounts}</h3>
            </CardHeader>
          </Card>
        </GridItem>

      </GridContainer>
      <GridContainer>

        {/* <GridItem xs={12} sm={12} md={12}>


        </GridItem> */}
        <GridItem xs={12} sm={12} md={12}>
        


        
        
          {/* <Card chart>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Email Subscriptions</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card> */}
        </GridItem>


        {/* <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="danger">
              <ChartistGraph
                className="ct-chart"
                data={completedTasksChart.data}
                type="Line"
                options={completedTasksChart.options}
                listener={completedTasksChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Completed Tasks</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={8}>


          {/* <CustomTabs
            title="Tasks:"
            headerColor="primary"
            tabs={[
              {
                tabName: "Bugs",
                tabIcon: BugReport,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0, 3]}
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={bugs}
                  />
                )
              },
              {
                tabName: "Website",
                tabIcon: Code,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0]}
                    tasksIndexes={[0, 1]}
                    tasks={website}
                  />
                )
              },
              {
                tabName: "Server",
                tabIcon: Cloud,
                tabContent: (
                  <Tasks
                    checkedIndexes={[1]}
                    tasksIndexes={[0, 1, 2]}
                    tasks={server}
                  />
                )
              }
            ]}
          /> */}
        </GridItem>
        {/* <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>Employees Stats</h4>
              <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="warning"
                tableHead={["ID", "Name", "Salary", "Country"]}
                tableData={[
                  ["1", "Dakota Rice", "$36,738", "Niger"],
                  ["2", "Minerva Hooper", "$23,789", "Curaçao"],
                  ["3", "Sage Rodriguez", "$56,142", "Netherlands"],
                  ["4", "Philip Chaney", "$38,735", "Korea, South"]
                ]}
              />
            </CardBody>
          </Card>
        </GridItem> */}
      </GridContainer>
    </div>
  );
}
